import ImagingModule from "./imaging";
import {agendaDirectory} from "./access/patientDirectory";
import {
  getDeviceTimeZone,
  localizeScheduleEntry
} from "./utils/timezone";
import {usePatientRecord} from "./access/usePatientRecord";
import {useAccess} from "./access/useAccess";
import { useEffect, useState } from "react";
import {
  db
} from "./firebase";
import {
  collection,
  query,
  where,
  onSnapshot,
  doc,
  updateDoc
} from "./access/firestore";
import CitaForm from "./CitaForm";
import PacienteForm from "./PacienteForm";
import OdontogramaPanel from "./OdontogramaPanel";
import PeriodontogramaPanel from "./PeriodontogramaPanel";
import FotosPanel from "./FotosPanel";
import OrtodonciaPanel from "./OrtodonciaPanel";
import ConsentimientosPanel from "./ConsentimientosPanel";
import PrescriptionPanel from './PrescriptionPanelDashboard';
import PatientWhatsAppPanel
  from "./PatientWhatsAppPanel";
import { useClinic }
  from "./context/ClinicContext";
import {
  sendWhatsAppMessage
} from "./services/sendWhatsApp";
import {
  sendWhatsAppFileVPS
} from "./services/whatsappVPS";
import {
  registerPayment
} from "./services/registerPayment";

import FileViewerModal
  from "./FileViewerModal";
import EvolutionPanel from "./EvolutionPanel";
import PlanTratamientoPanel
  from "./components/patients/PlanTratamientoPanel";
import HistoriaClinicaPanel from "./HistoriaClinicaPanel";
import CambraPanel from "./components/patients/CambraPanel";

import VexaConceptSelector from "./components/common/VexaConceptSelector";
import {
    Wallet,
    MessageCircle,
    Mail,
    Cake,
    CalendarDays,
    Clock3,
    CircleDollarSign,
    BadgeCheck,
    Stethoscope,
    ShieldAlert,
    ShieldCheck,
    ClipboardList,
    Pill,
    FileText,
    UserRound,
    ArrowLeft,
    ArrowRight
} from "lucide-react";

export default function PacienteDetalle({
  paciente:initialPatient,
  onBack,
  onIrACita
}) {
  const {patient:paciente}=usePatientRecord(initialPatient);
  const {can}=useAccess();
  const {
    clinicId,
    clinicData
  } = useClinic();
  const deviceTimeZone = getDeviceTimeZone();

  const tabAllowed = id => {
    const accessAllowed =
      id === "general"
        ? can("patients")
        : id === "ortodoncia"
          ? ["ceph", "bolton", "stl", "aligners"].some(key => can(key))
        : can(({ historiaClinica: "history", cambra: "history", plan: "treatment", evolucion: "evolution", fotos: "photos", odontograma: "odontogram", periodonto: "periodonto", consentimientos: "consents", recetas: "prescriptions", whatsapp: "whatsapp", tomografias: "imaging" })[id]);
    if (!accessAllowed) return false;
    const settingsKey = {
      historiaClinica: "history",
      cambra: "history",
      plan: "treatment",
      evolucion: "evolution",
      fotos: "photos",
      odontograma: "odontogram",
      periodonto: "periodonto",
      consentimientos: "consents",
      recetas: "prescriptions",
      tomografias: "imaging"
    }[id];
    if (id === "ortodoncia") {
      const enabled = clinicData?.settings?.clinical?.enabledModules;
      return ["ceph", "bolton", "stl", "aligners"].some(key => enabled?.[key] !== false);
    }
    return !settingsKey || clinicData?.settings?.clinical?.enabledModules?.[settingsKey] !== false;
  };

  const [citas, setCitas] = useState([]);
  const [pagos, setPagos] = useState([]);
  const [cuentasPorCobrar, setCuentasPorCobrar] = useState([]);

  const [showCitaForm, setShowCitaForm] =
    useState(false);

  const [form, setForm] = useState({});

  const [odontograma, setOdontograma] =
    useState({});

  const [odontogramaDirty, setOdontogramaDirty] =
    useState(false);

  const [guardandoOdontograma, setGuardandoOdontograma] =
    useState(false);

  const [tab, setTab] =
    useState("general");

  const [mostrarIndicadorScroll, setMostrarIndicadorScroll] = useState(false);

  useEffect(() => {
    const actualizarIndicador = () => {
      const documento = document.documentElement;
      const desplazamiento = window.scrollY || documento.scrollTop;
      const alturaVisible = window.innerHeight;
      const alturaTotal = Math.max(
        documento.scrollHeight,
        document.body?.scrollHeight || 0
      );

      setMostrarIndicadorScroll(
        alturaTotal > alturaVisible + 100 &&
        desplazamiento + alturaVisible < alturaTotal - 60
      );
    };

    actualizarIndicador();

    window.addEventListener("scroll", actualizarIndicador, { passive: true });
    window.addEventListener("resize", actualizarIndicador);

    const observador = new ResizeObserver(actualizarIndicador);
    observador.observe(document.documentElement);

    if (document.body) {
      observador.observe(document.body);
    }

    return () => {
      window.removeEventListener("scroll", actualizarIndicador);
      window.removeEventListener("resize", actualizarIndicador);
      observador.disconnect();
    };
  }, [tab, citas.length, pagos.length]);

  const [paginaActividad, setPaginaActividad] = useState({
    citas: 0,
    pagos: 0,
  });

  const calcularRegistrosPorPagina = () => {
    if (typeof window === "undefined") return 4;

    return Math.max(
      3,
      Math.min(12, Math.floor((window.innerHeight - 250) / 85))
    );
  };

  const [registrosPorPagina, setRegistrosPorPagina] = useState(
    calcularRegistrosPorPagina
  );

  useEffect(() => {
    const actualizarRegistros = () => {
      setRegistrosPorPagina(calcularRegistrosPorPagina());
    };

    window.addEventListener("resize", actualizarRegistros);
    actualizarRegistros();

    return () => {
      window.removeEventListener("resize", actualizarRegistros);
    };
  }, []);

  const [modoPago, setModoPago] =
    useState(false);

  const [citaSeleccionada, setCitaSeleccionada] =
    useState(null);

  const [abono, setAbono] =
    useState("");

  const [
    metodoPago,
    setMetodoPago
  ] = useState(
    "efectivo"
  );

  const [
    enviarReciboWhatsApp,
    setEnviarReciboWhatsApp
  ] = useState(
    true
  );

  const [showPacienteForm, setShowPacienteForm] =
    useState(false);

  const [
    pdfViewerOpen,
    setPdfViewerOpen
  ] = useState(false);

  const [
    pdfViewerUrl,
    setPdfViewerUrl
  ] = useState("");

  const [
    pdfViewerTitle,
    setPdfViewerTitle
  ] = useState("");

  const [
    pdfViewerWhatsAppUrl,
    setPdfViewerWhatsAppUrl
  ] = useState("");

  const [
    pdfViewerFileName,
    setPdfViewerFileName
  ] = useState("");

  const [
    sendingPdfWhatsApp,
    setSendingPdfWhatsApp
  ] = useState(false);

  const [
    searchPago,
    setSearchPago
  ] = useState("");

  const [
      registrandoPago,
      setRegistrandoPago
  ] = useState(false);

  const font = {
    fontFamily: "Inter, system-ui, Arial",
    fontSize: "13px"
  };

  useEffect(() => {

    if (!paciente) return;

      console.log("Paciente recibido:", paciente);

      console.log(
          "Odontograma recibido:",
          paciente.odontograma
      );

      setForm({ ...paciente });

      setOdontograma(
          paciente.odontograma || {}
      );

  }, [paciente]);

  const guardarOdontograma = (data) => {

      setOdontograma(data);

      setOdontogramaDirty(true);

  };

  const guardarOdontogramaFirestore = async () => {

      try {

          setGuardandoOdontograma(true);

          await updateDoc(

              doc(
                  db,
                  "clinics",
                  clinicId,
                  "pacientes",
                  paciente.id
              ),

              {
                  odontograma
              }

          );

          setOdontogramaDirty(false);

      } catch (err) {

          console.error(err);

          alert("Error al guardar el odontograma.");

      } finally {

          setGuardandoOdontograma(false);

      }

  };

  const direccionCompleta = [

    form.calle,

    form.numeroExterior
      ? `#${form.numeroExterior}`
      : "",

    form.numeroInterior
      ? `Int ${form.numeroInterior}`
      : "",

    form.colonia,
    form.ciudad,
    form.estado,
    form.pais,

    form.cp
      ? `CP ${form.cp}`
      : ""

  ]
    .filter(Boolean)
    .join(", ");

  const formatearFecha = (fecha) => {

    if (!fecha) return "";

    const meses = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    ];

    const [y, m, d] =
      fecha.split("-");

    return `${parseInt(d)} de ${
      meses[parseInt(m) - 1]
    } de ${y}`;
  };

  useEffect(() => {

    if (
      !paciente?.id ||
      !clinicId
    ) return;

    const q = query(

      agendaDirectory(db,clinicId),

      where(
        "pacienteId",
        "==",
        paciente.id
      )

    );

    return onSnapshot(

      q,

      snap => {

        setCitas(

          snap.docs.map(d => localizeScheduleEntry({

            id: d.id,
            ...d.data()

          }, deviceTimeZone))

        );

      },

      err => {

        console.error(
          "Error cargando citas:",
          err
        );

      }

    );

  }, [
    paciente?.id,
    clinicId,
    deviceTimeZone
  ]);

  useEffect(() => {

    if (
      !paciente?.id ||
      !clinicId
    ) return;

  const q = query(

    collection(
      db,
      "clinics",
      clinicId,
      "pagos"
    ),

    where(
      "pacienteId",
      "==",
      paciente.id
    )

  );

  return onSnapshot(

    q,

    snap => {

      setPagos(

        snap.docs.map(d => ({
          id: d.id,
          ...d.data()
        }))

      );

    },

    err => {

      console.error(
        "Error cargando pagos:",
        err
      );

    }

  );

  }, [
    paciente?.id,
    clinicId
  ]);

  useEffect(() => {

      if (
          !paciente?.id ||
          !clinicId
      ) return;

      return onSnapshot(

          collection(
              db,
              "clinics",
              clinicId,
              "pacientes",
              paciente.id,
              "cuentasPorCobrar"
          ),

          snap => {

              setCuentasPorCobrar(

                  snap.docs.map(d => ({

                      id: d.id,

                      ...d.data()

                  }))

              );

          },

          err => {

              console.error(
                  "Error cargando cuentas por cobrar:",
                  err
              );

          }

      );

  }, [

      paciente?.id,

      clinicId

  ]);
  
  const registrarPago = async () => {

      if (registrandoPago) return;

      try {

          setRegistrandoPago(true);

          await registerPayment({

              clinicId,

              clinicData,

              paciente,

              cuenta: citaSeleccionada,

              monto: abono,

              metodoPago,

              enviarReciboWhatsApp

          });

          setModoPago(false);

          setCitaSeleccionada(null);

          setAbono("");

      } catch (err) {

          console.error(
              "Error registrando pago:",
              err
          );

          alert(
              err.message ||
              "Ocurrió un error registrando el pago"
          );

      } finally {

          setRegistrandoPago(false);

      }

  };

  // =========================
  // CUENTAS POR COBRAR
  // =========================

  const formatearMoneda = (valor) => {

      return new Intl.NumberFormat(

          "es-MX",

          {

              style: "currency",

              currency: clinicData?.settings?.finance?.currency || "MXN"

          }

      ).format(

          Number(valor || 0)

      );

  };

  const totalPresupuesto =

      cuentasPorCobrar.reduce(

          (s, c) =>

              s +

              Number(c.total || 0),

          0

      );

  // =========================
  // PAGADO
  // =========================

  const totalPagado =

      cuentasPorCobrar.reduce(

          (s, c) =>

              s +

              Number(c.pagado || 0),

          0

      );

  // =========================
  // HISTORIAL DE PAGOS
  // =========================

  const pagosFiltrados =

      pagos

          .filter(p => {

              const texto =

                  `${p.folio || ""} ${p.concepto || ""}`
                      .toLowerCase();

              return texto.includes(

                  searchPago.toLowerCase()

              );

          })

          .sort((a, b) => {

              const fechaA =
                  a.fecha?.seconds || 0;

              const fechaB =
                  b.fecha?.seconds || 0;

              return fechaB - fechaA;

          });

  // =========================
  // SALDO PENDIENTE
  // =========================

  const saldo =

      cuentasPorCobrar.reduce(

          (s, c) =>

              s +

              Number(c.saldo || 0),

          0

      );

  const calcularEdad = (
    fechaNacimiento
  ) => {

    if (!fechaNacimiento)
      return null;

    const hoy = new Date();

    const nacimiento =
      new Date(fechaNacimiento);

    let edad =
      hoy.getFullYear() -
      nacimiento.getFullYear();

    const m =
      hoy.getMonth() -
      nacimiento.getMonth();

    if (
      m < 0 ||
      (
        m === 0 &&
        hoy.getDate() <
        nacimiento.getDate()
      )
    ) {
      edad--;
    }

    return edad;
  };

  const edad =
    calcularEdad(
      form.fechaNacimiento
    );

  const sendPdfByWhatsApp = async () => {

    try {

      if (
        !paciente?.whatsapp
      ) {

        alert(
          "El paciente no tiene WhatsApp registrado"
        );

        return;
      }

      setSendingPdfWhatsApp(
        true
      );
console.log(
  "PDF URL:",
  pdfViewerUrl
);

console.log(
  "PDF FILE:",
  pdfViewerFileName
);
      await sendWhatsAppFileVPS(

        clinicId,

        paciente.whatsapp,

        pdfViewerWhatsAppUrl,

        pdfViewerFileName,

        "Recibo de pago"

      );

      alert(
        "Documento enviado por WhatsApp"
      );

    } catch(err) {

      console.error(err);

      alert(
        "Error enviando documento"
      );

    } finally {

      setSendingPdfWhatsApp(
        false
      );

    }

  };

  const resumenClinico = [];

  if (form.diabetes)
    resumenClinico.push(
      "Diabetes"
    );

  if (form.hipertension)
    resumenClinico.push(
      "Hipertensión"
    );

  if (form.cardiopatias)
    resumenClinico.push(
      "Cardiopatías"
    );

  if (form.embarazo)
    resumenClinico.push(
      "Embarazo"
    );

  if (form.fumador)
    resumenClinico.push(
      "Fumador"
    );

  if (form.bruxismo)
    resumenClinico.push(
      "Bruxismo"
    );

  if (form.gingivitis)
    resumenClinico.push(
      "Gingivitis"
    );

  if (
    form.enfermedadPeriodontal
  )
    resumenClinico.push(
      "Enfermedad periodontal"
    );

  if (form.halitosis)
    resumenClinico.push(
      "Halitosis"
    );

  if (
    form.movilidadDental
  )
    resumenClinico.push(
      "Movilidad dental"
    );

  if (form.anticoagulantes)
    resumenClinico.push(
      "Anticoagulantes"
    );

  if (form.asma)
    resumenClinico.push(
      "Asma"
    );

  if (form.epilepsia)
    resumenClinico.push(
      "Epilepsia"
    );

  if (form.hepatitis)
    resumenClinico.push(
      "Hepatitis"
    );

  if (form.vih)
    resumenClinico.push(
      "VIH"
    );

  if (form.osteoporosis)
    resumenClinico.push(
      "Osteoporosis"
    );

  let asa = "ASA I";

  const condiciones =
    resumenClinico.length;

  if (condiciones >= 1)
    asa = "ASA II";

  if (condiciones >= 4)
    asa = "ASA III";

  const alertasMedicas = [];

  if (form.alergias) {

    alertasMedicas.push({
      color: "#dc2626",
      bg: "#fee2e2",
      texto:
        `Alergias: ${form.alergias}`
    });
  }

  if (form.diabetes) {

    alertasMedicas.push({
      color: "#7c3aed",
      bg: "#ede9fe",
      texto: "Paciente diabético"
    });
  }

  if (form.hipertension) {

    alertasMedicas.push({
      color: "#ea580c",
      bg: "#ffedd5",
      texto:
        "Hipertensión arterial"
    });
  }

  if (form.cardiopatias) {

    alertasMedicas.push({
      color: "#be123c",
      bg: "#ffe4e6",
      texto: "Cardiopatías"
    });
  }

  if (form.embarazo) {

    alertasMedicas.push({
      color: "#15803d",
      bg: "#dcfce7",
      texto: "Embarazo"
    });
  }

  if (form.bruxismo) {

    alertasMedicas.push({
      color: "#111827",
      bg: "#e5e7eb",
      texto: "Bruxismo"
    });
  }

  if (form.fumador) {

    alertasMedicas.push({
      color: "#92400e",
      bg: "#fef3c7",
      texto: "Paciente fumador"
    });
  }

  if (form.anticoagulantes) {

    alertasMedicas.push({
      color: "#1d4ed8",
      bg: "#dbeafe",
      texto:
        "Uso de anticoagulantes"
    });
  }
  
  const card = {
    background: "transparent",
    padding: 0,
    border: "none",
    borderRadius: 0,
    boxShadow: "none",
    display: "flex",
    flexDirection: "column",
    gap: 18,
    width: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    alignSelf: "start",
    position: "relative",
  };

  const button = {
    padding: "8px 12px",
    borderRadius: 8,
    border: "none",
    background: "#2563eb",
    color: "#fff",
    cursor: "pointer"
  };

  const buttonSecondary = {

      display:"inline-flex",

      alignItems:"center",

      gap:8,

      padding:"12px 18px",

      background:"#ffffff",

      border:"1px solid #e5e7eb",

      borderRadius:14,

      cursor:"pointer",

      fontWeight:600,

      color:"#111827",

      boxShadow:"0 4px 12px rgba(0,0,0,.06)",

      transition:"all .2s",

      marginBottom:24

  };

  const row = (
    label,
    value
  ) => (

    <div style={{
      display: "grid",
      gridTemplateColumns:
        "130px 1fr"
    }}>

      <strong>{label}</strong>

      <span>
        {value || "—"}
      </span>

    </div>
  );

  const infoCard = (icon, titulo, valor) => (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "54px minmax(0, 1fr)",
        alignItems: "center",
        gap: 18,
        padding: "20px 22px",
        borderRadius: 20,
        background: "#ffffff",
        border: "1px solid #e5ebf5",
        boxShadow: "0 3px 12px rgba(30, 64, 175, 0.025)",
        minWidth: 0,
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: 54,
          height: 54,
          borderRadius: 17,
          background: "linear-gradient(145deg, #e0eaff, #f0f5ff)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#2458d3",
          boxShadow: "inset 0 0 0 1px rgba(37,99,235,.07)",
        }}
      >
        {icon}
      </div>

      <div style={{ minWidth: 0 }}>
        <div
          style={{
            fontSize: 12,
            color: "#71819b",
            fontWeight: 700,
            letterSpacing: "0.4px",
            marginBottom: 7,
            textTransform: "uppercase",
          }}
        >
          {titulo}
        </div>

        <div
          style={{
            fontSize: 15,
            fontWeight: 650,
            color: "#172b4d",
            lineHeight: 1.6,
            overflowWrap: "anywhere",
          }}
        >
          {valor || "No registrado"}
        </div>
      </div>
    </div>
  );
  
  const clinicalCard = (icon, titulo, valor, danger = false) => (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "54px minmax(0, 1fr) auto",
        alignItems: "center",
        gap: 18,
        padding: "20px 22px",
        borderRadius: 20,
        border: danger
          ? "1px solid #fecaca"
          : "1px solid #e5ebf5",
        background: danger
          ? "linear-gradient(115deg, #fff1f2 0%, #ffffff 75%)"
          : "#ffffff",
        boxShadow: danger
          ? "0 5px 18px rgba(220, 38, 38, 0.055)"
          : "0 3px 12px rgba(30, 64, 175, 0.025)",
        minWidth: 0,
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: 54,
          height: 54,
          borderRadius: 17,
          background: danger
            ? "linear-gradient(145deg, #fee2e2, #fff1f2)"
            : "linear-gradient(145deg, #e0eaff, #f0f5ff)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: danger ? "#dc2626" : "#2458d3",
        }}
      >
        {icon}
      </div>

      <div style={{ minWidth: 0 }}>
        <div
          style={{
            fontSize: 12,
            color: danger ? "#b91c1c" : "#71819b",
            fontWeight: 750,
            letterSpacing: "0.4px",
            textTransform: "uppercase",
            marginBottom: 7,
          }}
        >
          {titulo}
        </div>

        <div
          style={{
            fontSize: 15,
            fontWeight: 700,
            color: danger ? "#991b1b" : "#172b4d",
            lineHeight: 1.6,
            overflowWrap: "anywhere",
          }}
        >
          {valor || "Sin registro"}
        </div>
      </div>

      <div
        style={{
          width: 9,
          height: 9,
          borderRadius: "50%",
          background: danger ? "#ef4444" : "#cbd5e1",
          boxShadow: danger
            ? "0 0 0 5px rgba(239,68,68,.09)"
            : "0 0 0 5px rgba(148,163,184,.10)",
          flexShrink: 0,
        }}
      />
    </div>
  );

  const appointmentCard = (cita) => {

      const saldo =
          Number(cita.saldo || 0);

      return (

          <div

              style={{
                  
                  background: "linear-gradient(145deg, #ffffff 0%, #fbfdff 100%)",
                  border: "1px solid #e5eaf3",
                  borderRadius: 16,
                  padding: 16,

                  display:"flex",

                  flexDirection:"column",

                  gap:11,

                  boxShadow:

                      "0 4px 12px rgba(0,0,0,.05)"

              }}

          >

              <div

                  style={{

                      display:"flex",

                      justifyContent:"space-between",

                      alignItems:"flex-start",

                      gap:12

                  }}

              >

                  <div>

                      <div

                          style={{

                              display:"flex",

                              alignItems:"center",

                              gap:10,

                              marginBottom:4

                          }}

                      >

                          <FileText

                              size={18}

                              color="#2563eb"

                          />

                          <span

                              style={{

                                  fontSize: 15,
                                  fontWeight: 750,
                                  color: "#1e293b",
                                  letterSpacing: "-0.2px",

                              }}

                          >

                              {cita.motivo}

                          </span>

                      </div>

                      <div

                          style={{

                              color:"#6b7280",

                              fontSize:13

                          }}

                      >

                          {cita.tratamiento || ""}

                      </div>

                  </div>

                  <div

                      style={{

                          padding:"6px 12px",

                          borderRadius:999,

                          background:

                              cita.estado==="pagada"

                                  ? "#dcfce7"

                                  : "#fef3c7",

                          color:

                              cita.estado==="pagada"

                                  ? "#166534"

                                  : "#92400e",

                          fontSize:12,

                          fontWeight:700

                      }}

                  >

                      {cita.estado}

                  </div>

              </div>

              <div

                  style={{

                      display:"flex",

                      alignItems:"center",

                      gap:10,

                      color:"#6b7280"

                  }}

              >

                  <CalendarDays size={17}/>

                  {formatearFecha(cita.fecha)}

                  ·

                  {cita.hora}

              </div>

              {cita.doctorNombre && (

                  <div

                      style={{

                          display:"flex",

                          alignItems:"center",

                          gap:10,

                          color:"#6b7280"

                      }}

                  >

                      <UserRound

                          size={17}

                          color="#6b7280"

                      />

                      {cita.doctorNombre}

                  </div>

              )}

              <div

                  style={{

                      display:"flex",

                      justifyContent:"space-between",

                      alignItems:"center",

                      borderTop:"1px solid #f3f4f6",

                      paddingTop:12

                  }}

              >

                  <div

                      style={{

                          display:"flex",

                          alignItems:"center",

                          gap:8,

                          color:"#6b7280"

                      }}

                  >

                      <CircleDollarSign size={18}/>

                      Saldo pendiente

                  </div>

                  <div

                      style={{

                          fontWeight:700,

                          fontSize:17,

                          color:

                              saldo>0

                                  ? "#dc2626"

                                  : "#16a34a"

                      }}

                  >

                      {

                          saldo>0

                              ? formatearMoneda(saldo)

                              : "Liquidada"

                      }

                  </div>

              </div>

          </div>

      );

  };
  
  const tabStyle = (active) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "11px 16px",
    minHeight: 44,
    borderRadius: 12,
    border: active
      ? "1px solid #2563eb"
      : "1px solid #e5eaf2",
    background: active
      ? "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)"
      : "#ffffff",
    color: active ? "#ffffff" : "#475569",
    cursor: "pointer",
    fontWeight: active ? 700 : 600,
    fontSize: 13,
    whiteSpace: "nowrap",
    boxShadow: active
      ? "0 4px 10px rgba(37, 99, 235, 0.18)"
      : "0 1px 2px rgba(15, 23, 42, 0.025)",
    transition: "all 0.18s ease",
  });

  if (!paciente?.id) {

    return (
      <div style={{
        padding: 20
      }}>
        Cargando paciente...
      </div>
    );
  }

  return (

    <div style={{
      display: "block",
      position: "static",
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      margin: 0,
      padding: "clamp(12px, 1.3vw, 20px)",
      boxSizing: "border-box",
      ...font
    }}>

      {/* ENCABEZADO ÚNICO DEL PACIENTE */}
      <section className="vd-patient-detail-hero" style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 20,
        marginBottom: 18,
        padding: "24px 28px",
        borderRadius: 18,
        background: "linear-gradient(110deg, #17366f 0%, #244f9d 65%, #3267b8 100%)",
        color: "#fff",
        boxShadow: "0 8px 24px rgba(23,54,111,.13)",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: 18,
          minWidth: 0,
          flex: "1 1 320px",
        }}>
          <div style={{
            width: 68,
            height: 68,
            flexShrink: 0,
            borderRadius: "50%",
            display: "grid",
            placeItems: "center",
            background: "#e8efff",
            color: "#17366f",
            fontSize: 23,
            fontWeight: 800,
          }}>
            {`${form.nombre || ""} ${form.apellidos || ""}`
              .trim()
              .split(/\s+/)
              .slice(0, 2)
              .map(p => p[0] || "")
              .join("")
              .toUpperCase() || "P"}
          </div>

          <div style={{ minWidth: 0 }}>
            <h2 style={{
              margin: 0,
              fontSize: 24,
              fontWeight: 800,
              lineHeight: 1.3,
              overflowWrap: "anywhere",
            }}>
              {form.nombre} {form.apellidos}
            </h2>

            <div style={{
              marginTop: 5,
              color: "#dbeafe",
              fontSize: 13,
            }}>
              {form.sexo || "Sexo no registrado"}
              {" · "}
              {edad ? `${edad} años` : "Edad no registrada"}
              {form.fechaNacimiento
                ? ` · ${formatearFecha(form.fechaNacimiento)}`
                : ""}
            </div>

            <div style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 7,
              marginTop: 11,
            }}>
              {resumenClinico.length
                ? resumenClinico.slice(0, 5).map((item, i) => (
                    <span key={i} style={{
                      padding: "5px 10px",
                      borderRadius: 20,
                      background: "rgba(255,255,255,.13)",
                      border: "1px solid rgba(255,255,255,.2)",
                      fontSize: 11,
                      fontWeight: 600,
                    }}>
                      {item}
                    </span>
                  ))
                : (
                  <span style={{ fontSize: 12, color: "#dbeafe" }}>
                    Sin antecedentes relevantes registrados
                  </span>
                )}
            </div>

            <div className="vd-patient-hero-contact" aria-label="Datos de contacto">
              <span>
                <MessageCircle size={12} />
                {form.whatsapp || "Sin WhatsApp"}
              </span>
              <span>
                <Mail size={12} />
                {form.correo || "Sin correo"}
              </span>
            </div>
          </div>
        </div>

        <div style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          flexWrap: "wrap",
        }}>
          <div style={{
            padding: "11px 15px",
            borderRadius: 12,
            background: "rgba(255,255,255,.12)",
            border: "1px solid rgba(255,255,255,.2)",
          }}>
            <div style={{ fontSize: 11, color: "#dbeafe" }}>
              Clasificación médica
            </div>
            <strong style={{ fontSize: 15 }}>{asa}</strong>
          </div>
          
          <button
            type="button"
            onClick={onBack}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 10,
              minHeight: 48,
              padding: "12px 22px",
              borderRadius: 12,
              border: "2px solid #ffffff",
              background: "#ffffff",
              color: "#1d4ed8",
              fontWeight: 800,
              fontSize: 14,
              cursor: "pointer",
              whiteSpace: "nowrap",
              boxShadow: "0 4px 12px rgba(0,0,0,0.22)",
              flexShrink: 0,
              position: "relative",
              zIndex: 5,
            }}
          >
            <ArrowLeft size={21} strokeWidth={2.8} />
            Volver al listado de pacientes
          </button>

          <button
            type="button"
            onClick={() => setShowPacienteForm(true)}
            style={{
              padding: "11px 15px",
              borderRadius: 10,
              border: "1px solid rgba(255,255,255,.5)",
              background: "#fff",
              color: "#17366f",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Editar paciente
          </button>
        </div>
      </section>

      {/* NAVEGACIÓN PREMIUM DE MÓDULOS */}
      <div className="vd-patient-detail-nav" style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        width: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        padding: 8,
        marginBottom: 20,
        background: "#fff",
        border: "1px solid #e0e8f4",
        borderRadius: 15,
        boxShadow: "0 5px 18px rgba(15,35,70,.045)",
      }}>
        {/* FLECHA IZQUIERDA */}
        <button
          type="button"
          aria-label="Ver módulos anteriores"
          title="Ver módulos anteriores"
          onClick={() => {
            const nav = document.getElementById("vexadent-modulos-scroll");
            if (nav) nav.scrollBy({ left: -280, behavior: "smooth" });
          }}
          style={{
            display: "grid",
            placeItems: "center",
            flex: "0 0 36px",
            width: 36,
            height: 40,
            border: "1px solid #dce6f4",
            borderRadius: 10,
            background: "#f7faff",
            color: "#244f9d",
            cursor: "pointer",
          }}
        >
          <ArrowLeft size={18} />
        </button>

        {/* ÁREA DESPLAZABLE */}
        <div
          id="vexadent-modulos-scroll"
          onWheel={e => {
            const nav = e.currentTarget;
            if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
              nav.scrollLeft += e.deltaY;
              e.preventDefault();
            }
          }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 7,
            flex: "1 1 0%",
            width: 0,
            minWidth: 0,
            overflowX: "auto",
            overflowY: "hidden",
            scrollBehavior: "smooth",
            scrollbarWidth: "none",
            overscrollBehaviorX: "contain",
            WebkitOverflowScrolling: "touch",
            touchAction: "pan-x",
          }}
        >
          {[
            ["general", "Información general"],
            ["historiaClinica", "Historia clínica"],
            ["cambra", "CAMBRA"],
            ["plan", "Plan de tratamiento"],
            ["evolucion", "Evolución"],
            ["fotos", "Fotografías clínicas"],
            ["odontograma", "Odontograma"],
            ["periodonto", "Periodontograma"],
            ["ortodoncia", "Ortodoncia"],
            ["tomografias", "Tomografías"],
            ["consentimientos", "Consentimientos"],
            ["recetas", "Recetas"],
            ["whatsapp", "WhatsApp"],
          ].filter(([id])=>tabAllowed(id)).map(([valor, etiqueta]) => {
            const activo = tab === valor;

            return (
              <button
                key={valor}
                type="button"
                aria-current={activo ? "page" : undefined}
                onClick={() => setTab(valor)}
                style={{
                  flex: "0 0 auto",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: 40,
                  padding: "10px 15px",
                  borderRadius: 10,
                  border: activo
                    ? "1px solid #244f9d"
                    : "1px solid transparent",
                  background: activo
                    ? "linear-gradient(135deg, #244f9d, #3267b8)"
                    : "transparent",
                  color: activo ? "#fff" : "#52627b",
                  cursor: "pointer",
                  fontWeight: activo ? 750 : 600,
                  fontSize: 12,
                  whiteSpace: "nowrap",
                  boxShadow: activo
                    ? "0 4px 10px rgba(36,79,157,.2)"
                    : "none",
                  transition: "background .18s ease, color .18s ease",
                }}
              >
                {etiqueta}
              </button>
            );
          })}
        </div>

        {/* FLECHA DERECHA */}
        <button
          type="button"
          aria-label="Ver más módulos"
          title="Ver más módulos"
          onClick={() => {
            const nav = document.getElementById("vexadent-modulos-scroll");
            if (nav) nav.scrollBy({ left: 280, behavior: "smooth" });
          }}
          style={{
            display: "grid",
            placeItems: "center",
            flex: "0 0 36px",
            width: 36,
            height: 40,
            border: "1px solid #dce6f4",
            borderRadius: 10,
            background: "#f7faff",
            color: "#244f9d",
            cursor: "pointer",
          }}
        >
          <ArrowRight size={18} />
        </button>
      </div>

      {tabAllowed(tab) && tab === "historiaClinica" && (
  
        <HistoriaClinicaPanel
          paciente={paciente}
          clinicId={clinicId}
        />

      )}

      {tabAllowed(tab) && tab === "cambra" && (
        <CambraPanel
          paciente={paciente}
        />
      )}

      {tab==="evolucion" && (

          <EvolutionPanel

              paciente={paciente}

              clinicId={clinicId}

              clinicData={clinicData}

              citas={citas}

              pagos={pagos}

          />

      )}

      {/* FOTOS */}
      {tabAllowed(tab) && tab === "fotos" &&
        paciente?.id && (

        <div style={{
          display: "flex",
          justifyContent: "center"
        }}>

          <FotosPanel
            pacienteId={paciente.id}
          />

        </div>
      )}

      {/* PLAN DE TRATAMIENTO */}

      {tabAllowed(tab) && tab === "plan" && (

          <PlanTratamientoPanel

              paciente={paciente}

          />

      )}

      {/* GENERAL */}
      {tabAllowed(tab) && tab === "general" && (
        <div style={{
          display: "flex",
          flexDirection: "column",
          gap: 18,
          width: "100%",
          minWidth: 0,
          color: "#102044",
        }}>

          {/* INDICADORES */}
          <section style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 280px), 1fr))",
            gap: 14,
            width: "100%",
            minWidth: 0,
            boxSizing: "border-box",
          }}>
            {[
              {
                titulo: "Próxima cita",
                valor: (() => {
                  const hoy = new Date();
                  const hoyKey = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, "0")}-${String(hoy.getDate()).padStart(2, "0")}`;
                  const proxima = [...citas]
                    .filter(c => c.estado === "activa" && c.fecha && c.fecha >= hoyKey)
                    .sort((a, b) => new Date(`${a.fecha}T${a.hora || "00:00"}`) - new Date(`${b.fecha}T${b.hora || "00:00"}`))[0];
                  return proxima
                    ? `${formatearFecha(proxima.fecha)} · ${proxima.hora || ""}`
                    : "No hay citas pendientes";
                })(),
                detalle: "Agenda del paciente",
                icono: <CalendarDays size={23} />,
                color: "#2458b3",
                fondo: "#f3f7ff",
                borde: "#d9e5fa",
              },
              {
                titulo: "Saldo pendiente",
                valor: formatearMoneda(saldo),
                detalle: "Importe por cobrar",
                icono: <Wallet size={23} />,
                color: "#d95d16",
                fondo: "#fff8f0",
                borde: "#f6dfc8",
              },
              {
                titulo: "Total pagado",
                valor: formatearMoneda(totalPagado),
                detalle: "Pagos registrados",
                icono: <CircleDollarSign size={23} />,
                color: "#16834a",
                fondo: "#f1fbf5",
                borde: "#d0efdc",
              },
            ].map(item => (
              <div key={item.titulo} style={{
                display: "flex",
                alignItems: "center",
                gap: 13,
                padding: "18px 17px",
                minWidth: 0,
                borderRadius: 15,
                border: `1px solid ${item.borde}`,
                background: `linear-gradient(135deg, #fff, ${item.fondo})`,
              }}>
                <div style={{
                  width: 44,
                  height: 44,
                  flexShrink: 0,
                  display: "grid",
                  placeItems: "center",
                  borderRadius: 12,
                  background: item.fondo,
                  color: item.color,
                }}>
                  {item.icono}
                </div>
                <div style={{ minWidth: 0 }}>
                  <div style={{
                    fontSize: 12,
                    color: "#64748b",
                    marginBottom: 5,
                  }}>
                    {item.titulo}
                  </div>
                  <div style={{
                    fontSize: 18,
                    fontWeight: 800,
                    color: item.color,
                    overflowWrap: "anywhere",
                  }}>
                    {item.valor}
                  </div>
                  <div style={{
                    fontSize: 11,
                    color: "#8492a8",
                    marginTop: 4,
                  }}>
                    {item.detalle}
                  </div>
                </div>
              </div>
            ))}
          </section>

          {/* DATOS PERSONALES Y CLÍNICOS */}
          <section style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 420px), 1fr))",
            gap: 18,
            alignItems: "stretch",
            width: "100%",
            minWidth: 0,
            boxSizing: "border-box",
          }}>

            <div style={{
              background: "#fff",
              border: "1px solid #dfe7f2",
              borderRadius: 16,
              padding: 19,
              minWidth: 0,
            }}>
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 10,
                marginBottom: 15,
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <UserRound size={23} color="#2458b3" />
                  <h3 style={{ margin: 0, fontSize: 18, fontWeight: 800 }}>
                    Datos personales
                  </h3>
                </div>
                <button
                  type="button"
                  onClick={() => setShowPacienteForm(true)}
                  style={{
                    padding: "7px 11px",
                    borderRadius: 9,
                    border: "1px solid #d5e2f5",
                    background: "#f8fbff",
                    color: "#2458b3",
                    fontSize: 11,
                    fontWeight: 700,
                    cursor: "pointer",
                  }}
                >
                  Editar
                </button>
              </div>

              {[
                ["Nombre completo", `${form.nombre || ""} ${form.apellidos || ""}`.trim() || "No registrado", <UserRound size={16} />],
                ["Teléfono / WhatsApp", form.whatsapp || form.telefono || "No registrado", <MessageCircle size={16} />],
                ["Correo electrónico", form.correo || "No registrado", <Mail size={16} />],
                ["Fecha de nacimiento", form.fechaNacimiento ? `${formatearFecha(form.fechaNacimiento)}${edad ? ` (${edad} años)` : ""}` : "No registrada", <Cake size={16} />],
                ["Género", form.sexo || "No registrado", <UserRound size={16} />],
                ["Dirección", direccionCompleta || "No registrada", <ArrowRight size={16} />],
              ].map(([etiqueta, valor, icono]) => (
                <div key={etiqueta} style={{
                  display: "grid",
                  gridTemplateColumns: "23px minmax(105px, .8fr) minmax(0, 1.4fr)",
                  alignItems: "center",
                  gap: 9,
                  padding: "10px 9px",
                  marginBottom: 7,
                  border: "1px solid #e6edf7",
                  borderRadius: 10,
                  background: "#fbfdff",
                  minWidth: 0,
                }}>
                  <span style={{ color: "#3970c9", display: "flex" }}>{icono}</span>
                  <span style={{ color: "#64748b", fontSize: 11 }}>{etiqueta}</span>
                  <span style={{
                    fontSize: 11,
                    fontWeight: 600,
                    overflowWrap: "anywhere",
                  }}>
                    {valor}
                  </span>
                </div>
              ))}

              <button
                type="button"
                onClick={() => setShowCitaForm(true)}
                style={{
                  ...button,
                  width: "100%",
                  padding: 12,
                  marginTop: 5,
                  fontWeight: 700,
                }}
              >
                Agendar cita
              </button>
            </div>

            <div style={{
              background: "#fff",
              border: "1px solid #dfe7f2",
              borderRadius: 16,
              padding: 19,
              minWidth: 0,
            }}>
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 15,
              }}>
                <Stethoscope size={23} color="#2458b3" />
                <h3 style={{ margin: 0, fontSize: 18, fontWeight: 800 }}>
                  Datos clínicos
                </h3>
              </div>

              {[
                ["Alergias", form.alergias || "Sin alergias registradas", <ShieldAlert size={16} />, Boolean(form.alergias)],
                ["Antecedentes médicos", form.antecedentesMedicos || form.antecedentes || "Sin antecedentes registrados", <ClipboardList size={16} />, false],
                ["Medicamentos actuales", form.medicamentos || "Sin medicamentos registrados", <Pill size={16} />, false],
                ["Enfermedades sistémicas", [
                  form.diabetes && "Diabetes",
                  form.hipertension && "Hipertensión",
                  form.cardiopatias && "Cardiopatías",
                  form.asma && "Asma",
                  form.epilepsia && "Epilepsia",
                  form.hepatitis && "Hepatitis",
                  form.vih && "VIH",
                  form.osteoporosis && "Osteoporosis",
                ].filter(Boolean).join(", ") || "Ninguna registrada", <ShieldCheck size={16} />, false],
                ["Hábitos", [
                  form.fumador && "Fumador",
                  form.bruxismo && "Bruxismo",
                ].filter(Boolean).join(", ") || "Sin hábitos registrados", <UserRound size={16} />, false],
                ["Notas importantes", form.otrosPadecimientos || "Ninguna", <FileText size={16} />, false],
              ].map(([etiqueta, valor, icono, alerta]) => (
                <div key={etiqueta} style={{
                  display: "grid",
                  gridTemplateColumns: "23px minmax(105px, .8fr) minmax(0, 1.4fr) 7px",
                  alignItems: "center",
                  gap: 9,
                  padding: "10px 9px",
                  marginBottom: 7,
                  border: `1px solid ${alerta ? "#fecaca" : "#e6edf7"}`,
                  borderRadius: 10,
                  background: alerta ? "#fff7f7" : "#fbfdff",
                  minWidth: 0,
                }}>
                  <span style={{
                    color: alerta ? "#dc2626" : "#3970c9",
                    display: "flex",
                  }}>
                    {icono}
                  </span>
                  <span style={{
                    color: alerta ? "#b91c1c" : "#64748b",
                    fontSize: 11,
                  }}>
                    {etiqueta}
                  </span>
                  <span style={{
                    fontSize: 11,
                    fontWeight: alerta ? 800 : 600,
                    color: alerta ? "#b91c1c" : "#102044",
                    overflowWrap: "anywhere",
                  }}>
                    {valor}
                  </span>
                  <span style={{
                    width: 7,
                    height: 7,
                    borderRadius: "50%",
                    background: alerta ? "#ef4444" : "#cbd5e1",
                  }} />
                </div>
              ))}
            </div>
          </section>

          {/* ACTIVIDAD PAGINADA */}
          <section style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 420px), 1fr))",
            gap: 18,
            alignItems: "stretch",
            width: "100%",
            minWidth: 0,
            boxSizing: "border-box",
          }}>

            {/* CITAS */}
            <div style={{
              display: "flex",
              flexDirection: "column",
              minWidth: 0,
              minHeight: 490,
              padding: 19,
              background: "#fff",
              border: "1px solid #dfe7f2",
              borderRadius: 16,
              boxSizing: "border-box",
            }}>
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 10,
                marginBottom: 5,
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <CalendarDays size={22} color="#2458b3" />
                  <h3 style={{ margin: 0, fontSize: 18, fontWeight: 800 }}>
                    Actividad de citas
                  </h3>
                </div>
                <span style={{
                  padding: "5px 9px",
                  borderRadius: 20,
                  background: "#eff6ff",
                  color: "#2458b3",
                  fontSize: 11,
                  fontWeight: 800,
                }}>
                  {citas.length}
                </span>
              </div>

              <div style={{
                fontSize: 11,
                color: "#64748b",
                marginBottom: 13,
              }}>
                <ArrowRight size={12} style={{ display: "inline", verticalAlign: "middle" }} />
                {" "}Selecciona una cita para abrirla en la agenda.
              </div>

              {(() => {
                const citasOrdenadas = [...citas].sort((a, b) =>
                  new Date(`${b.fecha || ""}T${b.hora || "00:00"}`) -
                  new Date(`${a.fecha || ""}T${a.hora || "00:00"}`)
                );
                const porPagina = registrosPorPagina;
                const totalPaginas = Math.max(1, Math.ceil(citasOrdenadas.length / porPagina));
                const pagina = Math.min(paginaActividad.citas, totalPaginas - 1);
                const visibles = citasOrdenadas.slice(pagina * porPagina, (pagina + 1) * porPagina);

                return (
                  <>
                    <div style={{ flex: 1 }}>
                      {visibles.length === 0 ? (
                        <div style={{
                          padding: 25,
                          textAlign: "center",
                          color: "#64748b",
                          background: "#f8fafc",
                          borderRadius: 12,
                        }}>
                          No hay citas registradas
                        </div>
                      ) : visibles.map(c => (
                        <button
                          key={c.id}
                          type="button"
                          title="Abrir esta cita en la agenda"
                          aria-label={`Abrir en la agenda la cita del ${c.fecha || ""} a las ${c.hora || ""}`}
                          onClick={() => onIrACita?.(c)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 11,
                            width: "100%",
                            minHeight: 67,
                            boxSizing: "border-box",
                            padding: "9px 10px",
                            marginBottom: 8,
                            textAlign: "left",
                            border: "1px solid #e5edf8",
                            borderRadius: 11,
                            background: "#fff",
                            cursor: "pointer",
                            color: "#102044",
                          }}
                          onMouseEnter={e => {
                            e.currentTarget.style.background = "#f4f8ff";
                            e.currentTarget.style.borderColor = "#a9c5f3";
                          }}
                          onMouseLeave={e => {
                            e.currentTarget.style.background = "#fff";
                            e.currentTarget.style.borderColor = "#e5edf8";
                          }}
                        >
                          <div style={{
                            width: 42,
                            minWidth: 42,
                            padding: "6px 2px",
                            textAlign: "center",
                            borderRadius: 9,
                            background: "#eff6ff",
                            color: "#2458b3",
                          }}>
                            <div style={{ fontSize: 17, fontWeight: 800 }}>
                              {c.fecha ? c.fecha.split("-")[2] : "—"}
                            </div>
                            <div style={{ fontSize: 9, fontWeight: 800 }}>
                              {c.fecha
                                ? new Date(`${c.fecha}T12:00:00`).toLocaleDateString("es-MX", { month: "short" }).replace(".", "").toUpperCase()
                                : ""}
                            </div>
                          </div>

                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{
                              fontSize: 12,
                              fontWeight: 800,
                              overflowWrap: "anywhere",
                            }}>
                              {c.tratamiento || c.concepto || c.motivo || "Cita dental"}
                            </div>
                            <div style={{
                              fontSize: 10,
                              color: "#64748b",
                              marginTop: 4,
                            }}>
                              {c.fecha ? formatearFecha(c.fecha) : "Fecha no registrada"}
                              {c.hora ? ` · ${c.hora}` : ""}
                            </div>
                            {c.doctorNombre && (
                              <div style={{
                                fontSize: 10,
                                color: "#64748b",
                                marginTop: 3,
                              }}>
                                {c.doctorNombre}
                              </div>
                            )}
                          </div>

                          <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 5,
                            color: "#2458b3",
                            fontSize: 10,
                            fontWeight: 800,
                            flexShrink: 0,
                          }}>
                            Abrir <ArrowRight size={14} />
                          </div>
                        </button>
                      ))}
                    </div>

                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 8,
                      paddingTop: 12,
                      marginTop: "auto",
                      borderTop: "1px solid #edf1f7",
                    }}>
                      <span style={{ fontSize: 11, color: "#64748b" }}>
                        {citasOrdenadas.length
                          ? `${pagina * porPagina + 1}–${Math.min((pagina + 1) * porPagina, citasOrdenadas.length)} de ${citasOrdenadas.length}`
                          : "0 citas"}
                      </span>
                      <div style={{ display: "flex", gap: 7 }}>
                        <button
                          type="button"
                          disabled={pagina === 0}
                          onClick={() => setPaginaActividad(prev => ({ ...prev, citas: Math.max(0, prev.citas - 1) }))}
                          style={{
                            padding: "8px 11px",
                            border: "1px solid #dbe5f3",
                            borderRadius: 8,
                            background: pagina === 0 ? "#f8fafc" : "#fff",
                            color: pagina === 0 ? "#b7c1d0" : "#2458b3",
                            cursor: pagina === 0 ? "not-allowed" : "pointer",
                          }}
                        >
                          Anterior
                        </button>
                        <button
                          type="button"
                          disabled={pagina >= totalPaginas - 1}
                          onClick={() => setPaginaActividad(prev => ({ ...prev, citas: Math.min(totalPaginas - 1, prev.citas + 1) }))}
                          style={{
                            padding: "8px 11px",
                            border: "1px solid #dbe5f3",
                            borderRadius: 8,
                            background: pagina >= totalPaginas - 1 ? "#f8fafc" : "#fff",
                            color: pagina >= totalPaginas - 1 ? "#b7c1d0" : "#2458b3",
                            cursor: pagina >= totalPaginas - 1 ? "not-allowed" : "pointer",
                          }}
                        >
                          Siguiente
                        </button>
                      </div>
                    </div>
                  </>
                );
              })()}
            </div>

            {/* FINANZAS */}
            <div style={{
              display: "flex",
              flexDirection: "column",
              minWidth: 0,
              minHeight: 490,
              padding: 19,
              background: "#fff",
              border: "1px solid #dfe7f2",
              borderRadius: 16,
              boxSizing: "border-box",
            }}>
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 10,
                marginBottom: 13,
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <FileText size={22} color="#2458b3" />
                  <h3 style={{ margin: 0, fontSize: 18, fontWeight: 800 }}>
                    Actividad financiera
                  </h3>
                </div>
                <span style={{
                  padding: "5px 9px",
                  borderRadius: 20,
                  background: "#f0fdf4",
                  color: "#16834a",
                  fontSize: 11,
                  fontWeight: 800,
                }}>
                  {pagosFiltrados.length}
                </span>
              </div>

              <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                gap: 9,
                marginBottom: 11,
              }}>
                <div style={{
                  padding: 11,
                  border: "1px solid #d0efdc",
                  borderRadius: 10,
                  background: "#f1fbf5",
                  minWidth: 0,
                }}>
                  <div style={{ fontSize: 10, color: "#64748b", marginBottom: 4 }}>
                    Total pagado
                  </div>
                  <div style={{
                    fontSize: 17,
                    fontWeight: 800,
                    color: "#16834a",
                    overflowWrap: "anywhere",
                  }}>
                    {formatearMoneda(totalPagado)}
                  </div>
                </div>
                <div style={{
                  padding: 11,
                  border: "1px solid #f6dfc8",
                  borderRadius: 10,
                  background: "#fff8f0",
                  minWidth: 0,
                }}>
                  <div style={{ fontSize: 10, color: "#64748b", marginBottom: 4 }}>
                    Saldo pendiente
                  </div>
                  <div style={{
                    fontSize: 17,
                    fontWeight: 800,
                    color: "#d95d16",
                    overflowWrap: "anywhere",
                  }}>
                    {formatearMoneda(saldo)}
                  </div>
                </div>
              </div>

              <input
                type="text"
                placeholder="Buscar folio o concepto..."
                value={searchPago}
                onChange={e => {
                  setSearchPago(e.target.value);
                  setPaginaActividad(prev => ({ ...prev, pagos: 0 }));
                }}
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  padding: "10px 12px",
                  borderRadius: 9,
                  border: "1px solid #dbe5f3",
                  fontSize: 11,
                  marginBottom: 10,
                }}
              />

              <button
                type="button"
                onClick={() => {
                  setModoPago(prev => !prev);
                  setCitaSeleccionada(null);
                  setAbono("");
                  setMetodoPago("efectivo");
                  setEnviarReciboWhatsApp(true);
                }}
                style={{
                  width: "100%",
                  padding: 11,
                  marginBottom: 10,
                  borderRadius: 9,
                  border: modoPago ? "1px solid #dbe5f3" : "none",
                  background: modoPago ? "#f8fafc" : "#2458b3",
                  color: modoPago ? "#334155" : "#fff",
                  fontWeight: 700,
                  fontSize: 12,
                  cursor: "pointer",
                }}
              >
                {modoPago ? "Cerrar registro de pago" : "Registrar pago"}
              </button>

              {modoPago && (
                <div style={{
                  padding: 13,
                  marginBottom: 10,
                  borderRadius: 10,
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                }}>
                  {cuentasPorCobrar.filter(c => Number(c.saldo || 0) > 0).length === 0 ? (
                    <div style={{ fontSize: 12, color: "#64748b" }}>
                      No hay tratamientos pendientes
                    </div>
                  ) : (
                    <>
                      <VexaConceptSelector
                        value={citaSeleccionada}
                        options={cuentasPorCobrar.filter(c => Number(c.saldo || 0) > 0)}
                        onChange={setCitaSeleccionada}
                      />
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="Monto a registrar"
                        value={abono}
                        onChange={e => setAbono(e.target.value)}
                        style={{
                          width: "100%",
                          boxSizing: "border-box",
                          padding: 11,
                          borderRadius: 8,
                          border: "1px solid #d1d5db",
                          background: "#fff",
                        }}
                      />
                      <select
                        value={metodoPago}
                        onChange={e => setMetodoPago(e.target.value)}
                        style={{
                          width: "100%",
                          boxSizing: "border-box",
                          padding: 11,
                          borderRadius: 8,
                          border: "1px solid #d1d5db",
                          background: "#fff",
                        }}
                      >
                        <option value="efectivo">Efectivo</option>
                        <option value="tarjeta">Tarjeta</option>
                        <option value="transferencia">Transferencia</option>
                      </select>
                      <label style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        fontSize: 12,
                      }}>
                        <input
                          type="checkbox"
                          checked={enviarReciboWhatsApp}
                          onChange={e => setEnviarReciboWhatsApp(e.target.checked)}
                        />
                        Enviar recibo por WhatsApp
                      </label>
                      <button
                        type="button"
                        onClick={registrarPago}
                        disabled={registrandoPago}
                        style={{
                          ...button,
                          padding: 11,
                          fontWeight: 700,
                          opacity: registrandoPago ? 0.65 : 1,
                        }}
                      >
                        {registrandoPago ? "Registrando..." : "Guardar pago"}
                      </button>
                    </>
                  )}
                </div>
              )}

              {(() => {
                const porPagina = registrosPorPagina;
                const totalPaginas = Math.max(1, Math.ceil(pagosFiltrados.length / porPagina));
                const pagina = Math.min(paginaActividad.pagos, totalPaginas - 1);
                const visibles = pagosFiltrados.slice(pagina * porPagina, (pagina + 1) * porPagina);

                return (
                  <>
                    <div style={{ flex: 1 }}>
                      {visibles.length === 0 ? (
                        <div style={{
                          padding: 22,
                          textAlign: "center",
                          color: "#64748b",
                          background: "#f8fafc",
                          borderRadius: 11,
                          fontSize: 12,
                        }}>
                          No se encontraron pagos
                        </div>
                      ) : visibles.map(p => (
                        <div key={p.id} style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          padding: "10px 9px",
                          marginBottom: 7,
                          border: "1px solid #e5edf7",
                          borderRadius: 10,
                          minWidth: 0,
                        }}>
                          <div style={{
                            width: 36,
                            height: 36,
                            flexShrink: 0,
                            display: "grid",
                            placeItems: "center",
                            borderRadius: 9,
                            background: "#eaf9ef",
                            color: "#16834a",
                          }}>
                            <CircleDollarSign size={19} />
                          </div>

                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{
                              fontSize: 11,
                              fontWeight: 800,
                              overflowWrap: "anywhere",
                            }}>
                              {p.concepto || "Pago"}
                            </div>
                            <div style={{
                              fontSize: 10,
                              color: "#64748b",
                              marginTop: 3,
                            }}>
                              {p.fecha?.seconds
                                ? new Date(p.fecha.seconds * 1000).toLocaleDateString("es-MX", {
                                    day: "numeric",
                                    month: "short",
                                    year: "numeric",
                                  })
                                : "Fecha no registrada"}
                              {p.metodoPago ? ` · ${p.metodoPago}` : ""}
                            </div>
                            {p.folio && (
                              <div style={{
                                fontSize: 9,
                                color: "#8492a8",
                                marginTop: 3,
                              }}>
                                Folio {p.folio}
                              </div>
                            )}
                          </div>

                          <div style={{ textAlign: "right", flexShrink: 0 }}>
                            <div style={{
                              fontSize: 13,
                              fontWeight: 800,
                              color: "#16834a",
                            }}>
                              {formatearMoneda(p.monto)}
                            </div>
                            {p.reciboUrl && (
                              <button
                                type="button"
                                onClick={() => {
                                  setPdfViewerUrl(p.reciboUrl);
                                  setPdfViewerWhatsAppUrl(p.reciboUrl);
                                  setPdfViewerFileName(`${p.folio || "recibo"}.pdf`);
                                  setPdfViewerTitle(p.folio || "Recibo");
                                  setPdfViewerOpen(true);
                                }}
                                style={{
                                  border: "none",
                                  background: "transparent",
                                  color: "#2458b3",
                                  fontSize: 10,
                                  fontWeight: 700,
                                  cursor: "pointer",
                                  marginTop: 4,
                                }}
                              >
                                Ver recibo
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>

                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 8,
                      paddingTop: 12,
                      marginTop: "auto",
                      borderTop: "1px solid #edf1f7",
                    }}>
                      <span style={{ fontSize: 11, color: "#64748b" }}>
                        {pagosFiltrados.length
                          ? `${pagina * porPagina + 1}–${Math.min((pagina + 1) * porPagina, pagosFiltrados.length)} de ${pagosFiltrados.length}`
                          : "0 pagos"}
                      </span>
                      <div style={{ display: "flex", gap: 7 }}>
                        <button
                          type="button"
                          disabled={pagina === 0}
                          onClick={() => setPaginaActividad(prev => ({ ...prev, pagos: Math.max(0, prev.pagos - 1) }))}
                          style={{
                            padding: "8px 11px",
                            border: "1px solid #dbe5f3",
                            borderRadius: 8,
                            background: pagina === 0 ? "#f8fafc" : "#fff",
                            color: pagina === 0 ? "#b7c1d0" : "#2458b3",
                            cursor: pagina === 0 ? "not-allowed" : "pointer",
                          }}
                        >
                          Anterior
                        </button>
                        <button
                          type="button"
                          disabled={pagina >= totalPaginas - 1}
                          onClick={() => setPaginaActividad(prev => ({ ...prev, pagos: Math.min(totalPaginas - 1, prev.pagos + 1) }))}
                          style={{
                            padding: "8px 11px",
                            border: "1px solid #dbe5f3",
                            borderRadius: 8,
                            background: pagina >= totalPaginas - 1 ? "#f8fafc" : "#fff",
                            color: pagina >= totalPaginas - 1 ? "#b7c1d0" : "#2458b3",
                            cursor: pagina >= totalPaginas - 1 ? "not-allowed" : "pointer",
                          }}
                        >
                          Siguiente
                        </button>
                      </div>
                    </div>
                  </>
                );
              })()}
            </div>
          </section>
        </div>
      )}

      {/* ODONTOGRAMA */}
      {tabAllowed(tab) && tab === "odontograma" && (

          <>

              <OdontogramaPanel
                  value={odontograma}
                  onChange={guardarOdontograma}
              />

              <div
                  style={{
                      position: "sticky",
                      bottom: 0,
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      gap: 16,
                      marginTop: 20,
                      padding: "16px 0",
                      background: "#f3f4f6",
                      zIndex: 100
                  }}
              >

                  {odontogramaDirty && (

                      <span
                          style={{
                              color: "#dc2626",
                              fontWeight: 600
                          }}
                      >
                          ● Cambios sin guardar
                      </span>

                  )}

                  <button
                      style={{
                          ...button,
                          opacity:
                              odontogramaDirty ? 1 : 0.6
                      }}
                      disabled={
                          !odontogramaDirty ||
                          guardandoOdontograma
                      }
                      onClick={
                          guardarOdontogramaFirestore
                      }
                  >

                      {

                          guardandoOdontograma

                              ? "Guardando..."

                              : odontogramaDirty

                              ? "Guardar odontograma"

                              : "✓ Guardado"

                      }

                  </button>

              </div>

          </>

      )}

      {/* PERIODONTO */}
      {tabAllowed(tab) && tab === "periodonto" &&
        paciente?.id && (

        <div style={{
          display: "flex",
          justifyContent: "center"
        }}>

          <PeriodontogramaPanel
            pacienteId={paciente.id}
          />

        </div>
      )}

      {/* ORTODONCIA */}
      {tabAllowed(tab) && tab === "ortodoncia" &&
        paciente?.id && (

        <div style={{
          display: "flex",
          justifyContent: "center"
        }}>

          <OrtodonciaPanel
            pacienteId={paciente.id}
            clinicId={clinicId}
          />

        </div>
      )}

      {tabAllowed(tab) && tab === "tomografias" && paciente?.id && <ImagingModule key={clinicId+":"+paciente.id} patient={paciente}/> }

      {/* CONSENTIMIENTOS */}
      {tabAllowed(tab) && tab === "consentimientos" &&
        paciente?.id && (

        <div style={{
          display: "flex",
          justifyContent: "center"
        }}>

          <ConsentimientosPanel
            paciente={form}
          />

        </div>
      )}

      {/* RECETAS */}
      {tabAllowed(tab) && tab === "recetas" &&
        paciente?.id && (

        <div style={{
          display: "flex",
          justifyContent: "center"
        }}>

          <PrescriptionPanel
              clinicId={clinicId}
              patient={{
                id: paciente.id,

                nombre:
                  `${form.nombre || ""} ${form.apellidos || ""}`,

                edad,

                peso:
                  Number(form.peso) || 0,

                sexo:
                  form.sexo || "",

                telefono:
                  form.telefono || "",

                whatsapp: 
                  form.whatsapp || "",

                whatsappCountryCode:
                    form.whatsappCountryCode || "+52",

                correo:
                  form.correo || "",

                direccion:
                  direccionCompleta,

                alergias:
                  form.alergias
                    ? form.alergias
                        .split(",")
                        .map(a => a.trim())
                    : [],

                diabetes:
                  form.diabetes || false,

                hipertension:
                  form.hipertension || false,

                cardiopatias:
                  form.cardiopatias || false,

                asma:
                  form.asma || false,

                embarazo:
                  form.embarazo || false,

                epilepsia:
                  form.epilepsia || false,

                hepatitis:
                  form.hepatitis || false,

                vih:
                  form.vih || false,

                osteoporosis:
                  form.osteoporosis || false,

                anticoagulantes:
                  form.anticoagulantes || false,

                antecedentesMedicos:
                  form.antecedentesMedicos || "",

                medicamentos:
                  form.medicamentos || "",

                otrosPadecimientos:
                  form.otrosPadecimientos || ""
              }}
          />

        </div>
      )}

      {/* WHATSAPP */}
      {tabAllowed(tab) && tab === "whatsapp" &&
        paciente?.id && (

        <PatientWhatsAppPanel

          paciente={form}

        />

      )}

      <FileViewerModal

        isOpen={
          pdfViewerOpen
        }

        onClose={() =>
          setPdfViewerOpen(
            false
          )
        }

        documentType="RECIBO DE PAGO"

        title={
          pdfViewerTitle
        }

        subtitle={
          paciente
            ? `${paciente.nombre || ""} ${paciente.apellidos || ""}`
            : ""
        }

        date={
          new Date()
            .toLocaleDateString(
              "es-MX"
            )
        }

        fileUrl={
          pdfViewerUrl
        }

        filename={
          pdfViewerFileName
        }

        mimeType="application/pdf"

        onWhatsApp={
          sendPdfByWhatsApp
        }

        sendingWhatsApp={
          sendingPdfWhatsApp
        }

      />

      {/* MODAL CITA */}
      {showCitaForm && (

        <CitaForm
          paciente={paciente}
          onClose={() =>
            setShowCitaForm(false)
          }
        />

      )}

      {/* MODAL PACIENTE */}
      {showPacienteForm && (

        <PacienteForm
          paciente={paciente}
          onClose={() =>
            setShowPacienteForm(false)
          }
          onSaved={(actualizado) => {

            setForm(actualizado);

            setShowPacienteForm(
              false
            );
          }}
        />

      )}

      {/* INDICADOR DE CONTENIDO INFERIOR */}
      {mostrarIndicadorScroll && (
        <button
          type="button"
          onClick={() => {
            window.scrollBy({
              top: Math.round(window.innerHeight * 0.7),
              behavior: "smooth",
            });
          }}
          aria-label="Desplazarse hacia abajo para ver más información"
          style={{
            position: "fixed",
            left: "50%",
            bottom: 22,
            transform: "translateX(-50%)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 10,
            padding: "12px 19px",
            borderRadius: 30,
            border: "1px solid rgba(255,255,255,.25)",
            background: "rgba(23,54,111,.95)",
            color: "#fff",
            boxShadow: "0 6px 22px rgba(15,35,70,.25)",
            fontSize: 12,
            fontWeight: 700,
            cursor: "pointer",
            backdropFilter: "blur(8px)",
            whiteSpace: "nowrap",
            maxWidth: "calc(100vw - 32px)",
          }}
        >
          <span>Desplázate para ver más</span>
          <span
            aria-hidden="true"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 23,
              height: 23,
              borderRadius: "50%",
              background: "rgba(255,255,255,.16)",
              fontSize: 17,
              lineHeight: 1,
            }}
          >
            ↓
          </span>
        </button>
      )}

    </div>
  );
}
